import type { JSX, ReactNode } from 'react';
import { Box, Divider, styled } from '@mui/material';
import CustomTypography from '@/components/Common/Typography';
import { corePalette } from '@/themes/colours';
import { POPUP_BLOCK_PADDING } from '@/constants/PatientDashboard/patientTimeline';
import type { IPopupColumn } from '@/types/PatientDashboard/PatientTimeline.types';
import { PopupValueCell } from './TimelinePopup.styles';

const SectionRoot = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: POPUP_BLOCK_PADDING,
  gap: '4px',
});

const HeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  minWidth: 0,
});

const SectionLabel = styled(CustomTypography)({
  flex: 1,
  minWidth: 0,
  fontSize: '11px',
  lineHeight: '140%',
  fontWeight: 500,
  color: corePalette.grey100,
  letterSpacing: '0.07em',
  textTransform: 'uppercase',
});

const ColumnLabel = styled(PopupValueCell)({
  fontSize: '11px',
  fontWeight: 500,
  color: corePalette.grey100,
  letterSpacing: '0.07em',
});

interface IProps {
  title: string;
  columns?: IPopupColumn[];
  children: ReactNode;
}

export default function TimelinePopupSection({ title, columns, children }: IProps): JSX.Element {
  return (
    <>
      <Divider />
      <SectionRoot>
        <HeaderRow>
          <SectionLabel>{title}</SectionLabel>
          {columns?.map((column) => (
            <ColumnLabel key={column.key} style={{ width: column.width }}>
              {column.label}
            </ColumnLabel>
          ))}
        </HeaderRow>
        {children}
      </SectionRoot>
    </>
  );
}
